<bl-modal-content #content
  [title]="'受付情報の紐付け'"
  [disableOkButton]="_disableOkButton"
>
  <div body>
    <div class="customer-vehicle-info">
      <vclcus-customer-vehicle-info-bar
        [customerName]="(_customerVehicleInfo$ | async)?.customerName"
        [customerNameKana]="(_customerVehicleInfo$ | async)?.customerNameKana"
        [contact]="(_customerVehicleInfo$ | async)?.contact"
        [vehicleName]="(_customerVehicleInfo$ | async)?.vehicleName"
    ></vclcus-customer-vehicle-info-bar>
    </div>

    <div class="customer-vehicle-candidate-title">Web予約情報と紐付ける登録済みの受付情報を下記から選択してください。</div>
    <div>
      <bl-reference-grid #refGrid
        [gridOptions]="_gridOptions"
        [gridHeight]="'_gridHeight'"
        [headerHeight]="_gridHeaderHeight"
        [rowHeight]="_gridRowHeight"
        [isOperable]="false"
        [totalCount]="_totalCount"
        [pageSizePatterns]="_gridSizePatterns"
        [showHeaderBtn]="true"
        [headerBtnText]="'＋　新規で受付を作成'"
        [pagination]="false"
        (headerBtnClickEvent)="onClickAdd()"
        (onReady)="onReadyGrid()"
        (changePageSize)="onChangePageSize($event)"
        (selectedRowEvent)="onSelectedRow($event)"
      >
      </bl-reference-grid>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-reception-link/web-reserve-reception-link.component.html